import { getInProgressParentSalesOptions } from '../../utils/items/get-in-progress-parent-sales-options';
export const getInProgressParentSalesItemOptionCount = () => {
    const inProgressOptions = getInProgressParentSalesOptions();
    return getSelectedOptionCount(inProgressOptions);
};
const getSelectedOptionCount = (selectedInProgressItems) => {
    const count = Object.values(selectedInProgressItems).reduce((total, option) => total + option.quantity, 0);
    return count;
};
